<template>
    <div class="container body fix-footer">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="card mt-5">
                    <div class="card-body text-center pt-5 pb-5">
                        <h1 class="far fa-check-circle green-check"></h1>
                        <h3 class="mt-3">{{ $t('verifyEmail.success') }}</h3>
                        <router-link to="home" class="btn btn-primary">{{$t('button.Home')}}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'VerifyEmailSuccess'
  };
</script>

<style scoped>

</style>
